import React from 'react';
import { MultiPortfolioReviewComponents } from './components/common/MultiPortfolioReviewComponents';
import { MultiHistoricalReviewComponents } from './components/specialized/MultiHistoricalReviewComponents';

export const MultiHistoricalReviewStep = () => {
  return (
    <>
      <MultiPortfolioReviewComponents.Content>
        <MultiPortfolioReviewComponents.LeftSideBar />
        <MultiPortfolioReviewComponents.RightSideBar>
          <MultiHistoricalReviewComponents.RightPane.Root>
            <MultiHistoricalReviewComponents.RightPane.Banner />
            <MultiHistoricalReviewComponents.RightPane.Content />
          </MultiHistoricalReviewComponents.RightPane.Root>
        </MultiPortfolioReviewComponents.RightSideBar>
      </MultiPortfolioReviewComponents.Content>
      <MultiHistoricalReviewComponents.Footer />
      <MultiHistoricalReviewComponents.ConfirmationModal />
    </>
  );
};
